import OrbMultiMail from "./orb-multi-mail";

export default OrbMultiMail